import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class GoodcardintcInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.url != 'https://fcm.googleapis.com/fcm/send') {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.getAuthToken()}`,
          // Secret_key: `HMJF9LCGULFFKERP5$$OM1`
        }

      });
    }

    return next.handle(request).pipe(catchError(error => this.handleError(error, request, next)))
  }

  private handleError(err: HttpErrorResponse, request: HttpRequest<any>, next: HttpHandler): Observable<any> {

    console.log(err)
    this.openSnackBar(err.error.message, 'snackBarError');
    // if token has expired
    if (err.status == 401) {

      this.router.navigate(['']);
    }
    // server error
    else if (err.status == 500) {
      //  this.router.navigate(['']);
    }
    // rethrow Error
    return throwError(err);
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

}
